<template>
  <div class="report">
    <div class="check-box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/all/report' }">数据报表</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>数据报表</el-breadcrumb-item> -->
      </el-breadcrumb>
      <div class="change-report">
        <div class="item" v-for="(item, index) in reportList" :key="index" :class="index == reportIndex ? 'active' : ''" @click="reportIndex = index">
          {{ item }}
        </div>
      </div>
      <div class="check-info">
        <div class="left">
          <span>配电室：</span>
          <el-select v-model="roomId" placeholder="请选择" @change="changeState">
            <el-option v-for="item in roomList" :key="item.id" :label="item.roomName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="left">
          <span>主进类型：</span>
          <el-select v-model="typeValue" placeholder="请选择" @change="changeState">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="right">
          <span>日期选择：</span>
          <el-date-picker :key="formInline.type" :picker-options="pickerOptions" v-show="timeTypeIndex === formInline.type" v-model="formInline.date" :type="formInline.type | dateType" :value-format="formInline.type | dateFormat" placeholder="请选择日期">
          </el-date-picker>
        </div>
        <div class="export" @click="exportExcelDataStatement">
          <i class="iconfont icon-daochu"></i>
          <p>导出</p>
        </div>
      </div>
      <div class="check-time-type">
        <div class="item" v-for="(item, index) in timeTypeList" :key="index" :class="index == timeTypeIndex ? 'active' : ''" @click="timeTypeIndex = index">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="table-box">
      <section v-for="(item, index) in dataList" :key="index">
        <div class="box-title">{{ item.equipmentDesc }}</div>
        <div class="item" v-for="(item2, index2) in item.list" :key="index2 + 'a'">
          <div class="iitem">
            <div v-for="(item3, index3) in item2[1]" :key="index3 + 'b'">
              {{ item3 }}
            </div>
          </div>
          <div class="iitem">
            <div v-for="(item4, index4) in item2[2]" :key="index4 + 'c'">
              {{ item4 }}
            </div>
          </div>
          <div class="iitem">
            <div v-for="(item5, index5) in item2[3]" :key="index5 + 'd'">
              {{ item5 }}
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import tool from "../utils/tool";
  export default {
    data() {
      return {
        typeList: [{
            value: 1,
            label: "高压主进",
          },
          {
            value: 2,
            label: "低压主进",
          },
        ],
        formInline: {
          type: 0,
          date: tool.formatDate("yyyy-MM-dd", new Date()),
        },
        pickerOptions: {
          firstDayOfWeek: 1,
        },
        typeValue: 1,
        roomList: [],
        roomId: null,
        reportList: ["主进报表", "回路报表"],
        reportIndex: 0,
        timeTypeList: ["日报表", "月报表", "年报表"],
        timeTypeIndex: 0,
        dataList: null,
        // date:tool.formatDate("yyyy-MM-dd", new Date()),
      };
    },
    created() {
      // this.date = this.formInline.date;
      // console.log(this.date);
      this.searchEquipmentRoomList();
    },
    watch: {
      "formInline.date" (v) {
        // console.log(v);
        this.searchDataStatement();
      },
      reportIndex(n, o) {
        if (n == 0) {
          this.typeValue = 1;
          this.typeList = [{
              value: 1,
              label: "高压主进",
            },
            {
              value: 2,
              label: "低压主进",
            },
          ];
        } else {
          this.typeValue = 3;
          this.typeList = [{
              value: 3,
              label: "高压回路",
            },
            {
              value: 4,
              label: "低压回路",
            },
          ];
        }
        this.searchDataStatement();
      },
      timeTypeIndex(v) {
        let dateLists = [{
            type: 0,
            date: tool.formatDate("yyyy-MM-dd", new Date()),
          },
          {
            type: 1,
            date: tool.formatDate("yyyy-MM", new Date())
          },
          {
            type: 2,
            date: tool.formatDate("yyyy", new Date())
          },
        ];
        this.formInline = dateLists[v];
        this.date = dateLists[v].date;
        this.searchDataStatement();
      },
    },
    filters: {
      dateType(v) {
        // // console.log(v)
        let type = {
          0: "date",
          1: "month",
          2: "year",
        };
        return type[v];
      },
      dateFormat(v) {
        let type = {
          0: "yyyy-MM-dd",
          1: "yyyy-MM",
          2: "yyyy",
        };
        return type[v];
      },
    },
    methods: {
      searchEquipmentByType() {
        // const roomId = this.$getCookie("roomId");
        this.$http
          .post("bma-distribution-service/equipment/searchEquipmentByType", {
            equipmentTypeId: 1,
            roomId: this.roomId,
          })
          .then((res) => {
            // console.log("res: ", res);
          });
      },
      // 查询配电室列表
      searchEquipmentRoomList() {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/equipmentRoom/searchEquipmentRoomListForOverview", {
              projectId: projectId,
            }
          )
          .then((res) => {
            if (res.data) {
              this.roomList = res.data;
              this.roomId = res.data[0].id;
              this.searchDataStatement();
            }
          });
      },
      searchDataStatement() {
        let list2s = [
          ["每小时电量"],
          ["当日用电量"],
          ["当月用电量"]
        ];
        let list3s = [
          ["当日累计用电量"],
          ["当月累计用电量"],
          ["当年累计用电量"]
        ];
        let list2 = list2s[this.timeTypeIndex];
        let list3 = list3s[this.timeTypeIndex];
        this.$http
          .post("bma-distribution-service/dataStatement/searchDataStatement", {
            date: this.formInline.date,
            equipmentType: this.typeValue,
            roomId: this.roomId,
            type: this.timeTypeIndex + 1,
          })
          .then((res) => {
            let formData = res.data.formData;
            let dataList = [];
            formData.forEach((item) => {
              let obj = {};
              obj.equipmentDesc = item.equipmentDesc;
              let list = item.dataList;
              let fList = [];
              let list1 = ["用电量/日期"];
              let len = list.length;
              // // console.log(list)
              for (let i = 0; i < list.length; i++) {
                // // console.log(i)
                // 15个之后的数据
                if ((i > 0 && i % 15 == 0) || i == list.length - 1) {
                  let obj = {
                    1: list1,
                    2: list2,
                    3: list3,
                  };
                  fList.push(obj);
                  list1 = ["用电量/日期"];
                  // list2 = list2s[this.timeTypeIndex];
                  // // list3 = list3s[this.timeTypeIndex];
                  if (this.timeTypeIndex === 1) {
                    list2 = ["当日用电量"];
                    list3 = ["当月累计用电量"];
                  } else if (this.timeTypeIndex === 2) {
                    list2 = ["当月用电量"];
                    list3 = ["当年累计用电量"];
                  } else {
                    list2 = ["每小时电量"];
                    list3 = ["当日累计用电量"];
                  }
                }
                list1.push(list[i].time);
                list2.push(list[i].electricity === '-' ? 0 : list[i].electricity);
                list3.push(list[i].accumElectricity === '-' ? 0 : list[i].accumElectricity);
                // console.log(list2)
              }
              // 1到16点
              // console.log(fList[0]);
              // // console.log(list);
              // // console.log(fList[0][3].length);
              // 多个数组的时候 1-16排序错误
              if (fList[0][2].length !== fList[0][1].length) {
                fList[0][2] = (fList[0][2].splice(0, 1)).concat(fList[0][2].splice(1, fList[0][2].length));
                fList[0][3] = (fList[0][3].splice(0, 1)).concat(fList[0][3].splice(1, fList[0][3].length));
              }
              if (fList[1]) {
                fList[1][1][fList[1][1].length] = list[list.length - 1].time;
                fList[1][2][fList[1][2].length] =
                  (list[list.length - 1].electricity === '-' ? 0 : list[list.length - 1].electricity);
                fList[1][3][fList[1][3].length] =
                  (list[list.length - 1].accumElectricity === '-' ? 0 : list[list.length - 1].accumElectricity);
              } else {
                fList[0][1][fList[0][1].length] = list[list.length - 1].time;
                fList[0][2][fList[0][2].length] =
                  (list[list.length - 1].electricity === '-' ? 0 : list[list.length - 1].electricity);
                fList[0][3][fList[0][3].length] =
                  (list[list.length - 1].accumElectricity === '-' ? 0 : list[list.length - 1].accumElectricity);
              }
              obj.list = fList;
              dataList.push(obj);
            });
            // console.log(dataList)
            this.dataList = dataList;
          });
      },
      exportExcelDataStatement() {
        this.$http({
          method: "post",
          url: "bma-distribution-service/dataStatement/exportExcelDataStatement",
          data: {
            date: this.formInline.date,
            equipmentType: this.typeValue,
            roomId: this.roomId,
            type: this.timeTypeIndex + 1,
          },
          responseType: "blob",
        }).then((res) => {
          let temp = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename=")[1];
          const data = res.data;
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let name = decodeURI(temp);
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      },
      // 状态改变
      changeState() {
        this.searchDataStatement();
      },
    },
  };
</script>

<style lang="less" scoped>
  .report {
    .check-box {
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      background: #f8f8f9;
      border-bottom: 1px solid #eeeeef;
      .change-report {
        display: flex;
        margin-top: 25px;
        .item {
          width: 106px;
          height: 32px;
          background: #eaedef;
          border-radius: 5px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          color: #8e9fa8;
          margin-right: 20px;
          cursor: pointer;
          &.active {
            color: #fff;
            background: #1460e0;
          }
        }
      }
      .check-info {
        margin-top: 23px;
        display: flex;
        position: relative;
        >div {
          span {
            font-size: 16px;
            font-weight: 600;
            text-align: right;
            width: 100px;
          }
        }
        .left {
          margin-right: 40px;
          display: flex;
          align-items: center;
          .el-select {
            width: 200px;
          }
        }
        .export {
          width: 95px;
          height: 40px;
          background: #1460e0;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          position: absolute;
          right: 30px;
          cursor: pointer;
          i {
            color: #fff;
            font-size: 18px;
            line-height: 40px;
          }
          p {
            color: #fff;
            font-size: 18px;
            line-height: 40px;
          }
        }
      }
      .check-time-type {
        display: flex;
        margin-top: 25px;
        .item {
          font-size: 16px;
          margin-right: 15px;
          color: #0e223d;
          cursor: pointer;
          padding-bottom: 15px;
          &.active {
            font-weight: 600;
            border-bottom: 2px solid rgba(20, 96, 224, 1);
          }
        }
      }
    }
    .table-box {
      padding: 15px;
      section {
        width: 1622px;
        height: 267px;
        background: #fff;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 15px;
        box-sizing: border-box;
        border-top: 2px solid #1460e0;
        .box-title {
          font-size: 14px;
          font-weight: 600;
          line-height: 24px;
          color: #0e223d;
        }
        .item {
          margin-top: 15px;
          border-top: 1px solid #e1e1e1;
          .iitem {
            display: flex;
            border-left: 1px solid #e1e1e1;
            &:nth-of-type(2n-1) {
              div {
                background: #fafafa;
              }
            }
            div {
              width: 100px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              font-size: 12px;
              color: #0e223d;
              box-sizing: border-box;
              display: block;
              position: relative;
              border-right: 1px solid #e1e1e1;
              border-bottom: 1px solid #e1e1e1;
            }
          }
        }
      }
    }
  }
</style>